"use strict";

angular.module("internal.exams").controller("InternalExamSkillCategories", [
    "$scope",
    "EXSkillCategory",
    "$rootScope",
    "Resource",
    "Cache",
    function($scope, EXSkillCategory, $rootScope, Resource, Cache) {
        EXSkillCategory.get().then(function(SkillCategories) {
            $scope.SkillCategories = SkillCategories;
            $scope.loading = false;
        });

        $scope.columns = [
            {
                label: "Name",
                field: "name",
                link: {
                    state: "internal.exams.administrative.skillcategory",
                    params: [
                        {
                            name: "examSkillCategoryID",
                            field: "id"
                        },
                        {
                            name: "id",
                            field: "id"
                        }
                    ]
                }
            },

            {
                label: "Total Count",
                field: "skillcount"
            },

            {
                label: "Last Modified",
                field: "modifiedon",
                type: "date"
            },
            {
                label: "Modified By",
                field: "modifiedby"
            }
        ];
    }
]);
